import React, { Component } from "react";
//import { Input } from '@chakra-ui/react';

//import { Navbar, Table, Form } from "react-bootstrap";
import { MdShare, MdEdit, MdDownload, MdRemove, MdAdd } from 'react-icons/md';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";

import {
  Avatar,
  Box,
  Button,
  DarkMode,
  Flex,
  Icon,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

const initialForm = {
  id: 1,
  Articulo: '',
  Precio: 0,
  Cantidad: 0,
  Descripcion: '',
  Total: 0,

}


export default class Hello extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapseID: "",
      Total:0,
      Secciones:[],
      formArray: [
        {
          ...initialForm
        }
      ]
    };
    this.addNewForm = this.addNewForm.bind(this);
  }

  addNewForm = () => {
    let newForm = { ...initialForm };
    newForm.id = this.state.formArray[this.state.formArray.length - 1].id + 1;
    this.setState(prevState => {
      return {
        ...prevState,
        formArray: [...prevState.formArray, newForm]
      }
    })
  }

  setSeccionesXD = (e) => {
    let { Secciones } = this.state;
    Secciones = e;
    this.setState({
      Secciones
    })

  }

  setTotal = (e) => {
    let { Total } = this.state;
    Total = e;
    this.setState({
      Total
    })

  }



  setSecciones = (e) => {
    let { Seccion } = this.state;
    Seccion = e;
    this.setState({
      Seccion
    })

  }
  setFormValue = (e, index) => {
    let { formArray } = this.state;
    formArray[index][e.target.name] = e.target.value;
    this.setState({
      formArray
    })

    if (e.target.name == 'Precio' || e.target.name == 'Cantidad') {
      let mul = formArray[index]['Precio'] * formArray[index]['Cantidad'];
      formArray[index]['Total'] = mul;
      this.setState({
        formArray
      })

      let suma = 0;
      let userFullnames = formArray.map(function (element) {
        suma += element.Total;
      })
      this.setTotal(suma);
      //alert(suma);
     // formArray[index]['Total']
     // alert(mul);ƒ
    }

  }

  setSeccionesX = (e, index) => {
    let { formArray } = this.state;
    formArray[index]['Articulo'] = e;
    this.setState({
      formArray
    })
  }


  setFormValueArticulo = (e, index) => {
    let { formArray } = this.state;
    formArray[index]['Articulo'] = e;
    this.setState({
      formArray
    })
  }

  removeForm = (id) => {
    const formArray = this.state.formArray.filter(form => form.id != id)
    this.setState({ formArray })

    let suma = 0;
    let userFullnames = formArray.map(function (element) {
      suma += element.Total;
    })
    this.setTotal(suma);
  }


  componentDidMount(){
    this.fetchData();
  }

   fetchData = async () => {
    try {
      let url2 = process.env.REACT_APP_URL_SERVER + '/secciones';

      // const response = await fetch(url);
      // const result = await response.json();
      // setData(result);

      const responsex = await fetch(url2);
      
      let resultx = await responsex.json();
      resultx = 
      //setgenero(resultx);
      this.setSeccionesXD(resultx);

      //console.error(resultx)

      console.log('asdkadaksjdlkadjlajdALJLAJALJASDKJA')
      console.log(this.state.Secciones)
      // this.setState({Secciones:resultx})
      // console.log(this.state.Secciones)

      // const xD: RowObj[] = result;
      // setData(xD);
      //  setisLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  render() {
    const Productos = [
      { id: 1, name: 'Silla de Madera', country: 'Austria' },
      { id: 2, name: 'Sofa', country: 'Belgium' },
      { id: 3, name: 'Mesa', country: 'Canada' },
      { id: 4, name: 'Pancartas', country: 'Denmark' },
      { id: 5, name: 'Lonas', country: 'Egypt' },
    ];

  
  
    

    return (
      <div>
        <div className="import">
          {/* <h1>Import New Schedule</h1> */}
          <div className="importTable">
            <Table className="table" id="tables" responsive='md' >
              <thead className="thead-dark">
                <tr style={{ alignContent: 'start', alignItems: 'start',alignSelf:'start' }}>
                  <th>Seccion</th>
                  

                </tr>
              </thead>
              <tbody>
                {this.state.formArray.map((form, index) => (
                  <tr key={form.id}>
                    <td>
                      <AutoComplete openOnFocus onChange={(e) => this.setFormValueArticulo(e, index)} style={{ marginTop: 0 }} >
                        <AutoCompleteInput variant="filled"
                          type="text"
                          fontWeight='500'
                          _placeholder={{ fontWeight: '400', color: 'secondaryGray.600' }}
                          placeholder="Selecciona una Seccion"
                          h='44px'
                          maxH='44px'
                          w='174px'
                          maxW='174px'
                          name="Seccion"

                        />
                        <AutoCompleteList
                          id="Seccion"

                        >
                          {this.state.Secciones.map((cliente) => (
                            <AutoCompleteItem
                              key={`option-${cliente.id}`}
                              label={cliente.Seccion}
                              value={cliente.Seccion}
                            >
                              {cliente.name}
                            </AutoCompleteItem>
                          ))}
                        </AutoCompleteList>
                      </AutoComplete>

                      {/* <Input
                        type="text"
                        fontWeight='500'
                        variant='filled'
                        _placeholder={{ fontWeight: '400', color: 'secondaryGray.600' }}
                        h='44px'
                        maxH='44px'
                        w='174px'
                        maxW='174px'
                        defaultValue={form.Articulo}
                        onChange={(e) => this.setFormValue(e, index)}
                        name="Articulo"
                        placeholder="Articulo: Silla"
                        id="Articulo"
                      /> */}
                      {/* <select name="queueType" 
                    defaultValue={form.queueType} 
                    onChange={(e)=>this.setFormValue(e, index)}>
                      <option>Veteran Affairs</option>
                      <option>Older Australians</option>
                      <option>Disability Sickness Carers</option>
                      <option>Report Employment Income</option>
                    </select> */}
                    </td>
                   
                    <td>
                      <IconButton aria-label="1" me='2px' px='0px' variant='no-hover' bg='transparent' onClick={() => this.removeForm(form.id)}>
                        <Icon as={MdRemove} h='24px' w='24px' color='red.300' />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <IconButton onClick={this.addNewForm}>
              <Icon as={MdAdd} h='24px' w='24px' color='green.300' />
            </IconButton>
            {/* <button id="addRow" type="button" onClick={this.addNewForm}>+ Add</button> */}
          </div>
        </div>
        <center>
        <Flex style={{alignSelf:'center',alignItems:'center'}}>
        {/* <Text style={{fontWeight:'bold',alignSelf:'center'}}>TOTAL: {this.state.Total}</Text> */}
        </Flex>
        </center>
        {/* <pre>
        {JSON.stringify(this.state.formArray)}
        </pre> */}
      </div>
    );
  }
}

